"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _heartbeat = _interopRequireDefault(require("./hotspot-designs/heartbeat"));

var _swirlHotspot = _interopRequireDefault(require("./hotspot-designs/swirlHotspot"));

var _bigPulse = _interopRequireDefault(require("./hotspot-designs/bigPulse"));

var _diamondHotspot = _interopRequireDefault(require("./hotspot-designs/diamondHotspot"));

var _speechBubble = _interopRequireDefault(require("./hotspot-designs/speech-bubble"));

var _custom = _interopRequireDefault(require("./hotspot-designs/custom"));

var _circle = _interopRequireDefault(require("./hotspot-designs/circle"));

var _directSum = _interopRequireDefault(require("./hotspot-designs/directSum"));

var _plus = _interopRequireDefault(require("./hotspot-designs/plus"));

var _pulse = _interopRequireDefault(require("./hotspot-designs/pulse"));

var _clock = _interopRequireDefault(require("./hotspot-designs/clock"));

var _countdown = _interopRequireDefault(require("./hotspot-designs/countdown"));

var _boundingBox = _interopRequireDefault(require("./hotspot-designs/boundingBox"));

var _defaultHotspot = _interopRequireDefault(require("./hotspot-designs/defaultHotspot"));

var _standardHotspot = _interopRequireDefault(require("./hotspot-designs/standardHotspot"));

var _standardTail = _interopRequireDefault(require("./hotspot-designs/standardTail"));

var _bigButton = _interopRequireDefault(require("./hotspot-designs/bigButton"));

var _invisible = _interopRequireDefault(require("./hotspot-designs/invisible"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable quote-props */


var _default = {
  '100616': _swirlHotspot.default,
  '100617': _bigPulse.default,
  '100615': _diamondHotspot.default,
  '100614': _speechBubble.default,
  '100613': _heartbeat.default,
  '100596': _custom.default,
  '100346': _circle.default,
  '100139': _directSum.default,
  '100349': _plus.default,
  '100081': _pulse.default,
  '100619': _clock.default,
  '100231': _countdown.default,
  '100345': _boundingBox.default,
  '100080': _defaultHotspot.default,
  '100344': _standardHotspot.default,
  '100347': _standardTail.default,
  '100618': _bigButton.default,
  '100023': _invisible.default
};
exports.default = _default;